import styled from 'styled-components';

export const Portrait = styled.img`
  display: flex;
  width: 5rem;
  padding: 0.5rem 0;
`;
